import {KTIcon} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import {ErrorMessage, Field, Form, Formik} from 'formik'
import {FormikHelpers} from 'formik'
import Swal from 'sweetalert2'
import {baseUrl} from '../../core'
import secureLocalStorage from 'react-secure-storage'
import usePostApi from '../../custom_hooks/usePostApi'
import {useParams} from 'react-router-dom'

const AddExpenseType = (props: any) => {
  const {refreshData} = props.id
  const intl = useIntl()
  const {execute} = usePostApi()
  const {id}: any | null = useParams()
  const userInfo: any | null = secureLocalStorage.getItem('user_info')
  const {organization_id} = userInfo || {}
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(intl.formatMessage({id: 'LABEL.NAME_REQUIRED'})),
    expense_code: Yup.string().required(intl.formatMessage({id: 'LABEL.CODE_REQUIRED'})),
    coa_code: Yup.string().required(intl.formatMessage({id: 'LABEL.COA_ID_REQUIRED'})),
    description: Yup.string().required(intl.formatMessage({id: 'LABEL.DESCRIPTION_REQUIRED'})),
    status: Yup.boolean().required(intl.formatMessage({id: 'LABEL.STATUS_REQUIRED'})),
  })

  const handleSubmit = async (values: any, {resetForm}: FormikHelpers<any>) => {
    const url = `${baseUrl}/hrConfig/expenseTypes`
    try {
      const requestData = {
        organization_id: organization_id,
        expense_type_name: values.name,
        expense_code: values.expense_code,
        coa_code: values.coa_code,
        description: values.description,
        status: values.status ? 1 : 0,
      }
      await execute(url, 'POST', requestData, id)
      resetForm()
      refreshData()
      const closeBtn = document.querySelector(
        '#kt_modal_add_expenseType [data-bs-dismiss="modal"]'
      ) as HTMLElement
      if (closeBtn) {
        closeBtn.click()
      }
      Swal.fire({
        title: 'Expense Type Added Successfully',
        text: intl.formatMessage({id: 'LABEL.CHANGES_SAVED'}),
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-light-primary btn-sm',
        },
      })
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'LABEL.OOPS'}),
        text: intl.formatMessage({id: 'LABEL.SOMETHING_WRONG'}),
      })
    }
  }
  const handleCancel = (resetForm: any) => {
    resetForm()
  }
  return (
    <div>
      <Formik
        initialValues={{
          name: '',
          expense_code: '',
          coa_code: '',
          description: '',
          status: true,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({values, resetForm}) => {
          return (
            <Form>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h5 className='modal-title'>
                      {intl.formatMessage({id: 'LABEL.ADD_EXPENSE_TYPE'})}
                    </h5>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-danger'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      <KTIcon iconName='cross' className='fs-2' />
                    </div>
                  </div>
                  <div className='modal-body position-relative'>
                    <div>
                      <div className='form-floating flex-fill mb-4'>
                        <Field
                          type='text'
                          className='form-control'
                          id='floatingInput'
                          placeholder='type...'
                          name='name'
                        />
                        <label htmlFor='floatingInput'>
                          {intl.formatMessage({id: 'LABEL.NAME'})}
                        </label>
                        <ErrorMessage component='div' className='text-danger' name='name' />
                      </div>
                      <div className='mb-4 d-flex'>
                        <div className='form-floating flex-fill'>
                          <Field
                            type='text'
                            className='form-control'
                            id='expense_code'
                            placeholder='type...'
                            name='expense_code'
                          />
                          <label htmlFor='expense_code'>
                            {intl.formatMessage({id: 'LABEL.CODE'})}
                          </label>
                          <ErrorMessage
                            component='div'
                            className='text-danger'
                            name='expense_code'
                          />
                        </div>
                        <div className='form-floating flex-fill ms-2'>
                          <Field
                            type='text'
                            className='form-control'
                            id='floatingInput'
                            placeholder='type...'
                            name='coa_code'
                          />
                          <label htmlFor='floatingInput'>
                            {intl.formatMessage({id: 'LABEL.COA_ID'})}
                          </label>
                          <ErrorMessage component='div' className='text-danger' name='coa_code' />
                        </div>
                      </div>
                      <div className='form-floating mb-4'>
                        <Field
                          type='text'
                          className='form-control'
                          id='description'
                          placeholder='type...'
                          name='description'
                        />
                        <label htmlFor='description'>
                          {intl.formatMessage({id: 'LABEL.DESCRIPTION'})}
                        </label>
                        <ErrorMessage component='div' className='text-danger' name='description' />
                      </div>
                      <div className='form-floating flex-fill'>
                        <div className='form-check form-check-solid form-switch mb-0'>
                          <Field
                            className='form-check-input w-40px h-20px'
                            type='checkbox'
                            name='status'
                            id='toggle'
                          />
                          <span
                            className={`me-4 fw-bold ${
                              values.status ? 'text-success' : 'text-danger'
                            }`}
                          >
                            {values.status ? 'Active' : 'Inactive'}
                          </span>
                          <ErrorMessage component='div' className='text-danger' name='status' />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer text-end'>
                    <div
                      className='btn btn-sm btn-secondary m-2'
                      onClick={() => handleCancel(resetForm)}
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      {intl.formatMessage({id: 'LABEL.CANCEL'})}
                    </div>
                    <button className='btn btn-light-primary btn-sm' type='submit'>
                      <KTIcon iconName='check' className='fs-7' />
                      {intl.formatMessage({id: 'BTN.SAVE'})}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export {AddExpenseType}
